export default __webpack_public_path__ + "static/media/Group38303.3280ebd6.png";